export default __webpack_public_path__ + "static/media/upmenu.70328bb3.svg";